export default {
  common: {
    account: 'Account',
    myPage: 'My Page',
    booking: 'My Booking',
    logout: 'Logout',
    save: 'Save',
    colon: ': ',
    multiply: '×',
    next: 'Next',
    return: 'Return',
    toPay: 'Payment',
    update: 'Update',
    search: 'Search',
    space: ' ',
    add: 'Add',
    confirm: 'Confirm',
    cancel: 'Cancel',
    searchPlaceholder: 'Search...',
    tilde: '~',
    showMore: 'Show More'
  },
  price: {
    primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
    jpyWord: 'JPY',
    jpySymbol: '¥'
  },
  footer: {
    terms: 'Terms of Use',
    cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
    copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.'
  },
  validation: {
    required: '{{field}} is required',
    invalid: 'Please enter a valid {{field}}',
    password:
      'Please enter a password with at least 8 characters, including uppercase, lowercase, symbols, and numbers',
    imageType: 'Please select an image file',
    fileSize: 'Please select a file less than {{size}}MB',
    range: 'Please enter a value between {{min}} and {{max}}',
    requiredSelect: 'Please select an {{field}} option',
    emailNotMatch: 'Email addresses do not match',
    emailAlreadyRegistered:
      'This email is already registered. Please log in instead.'
  },
  firebase: {
    'auth/wrong-password': 'The email or password entered is incorrect.',
    'auth/user-not-found': 'The email or password entered is incorrect.',
    'auth/email-already-in-use': 'Email already taken.',
    'auth/too-many-requests':
      'Too many failed login attempts, please resetting your password or try again later.'
  },
  apiErrors: {
    baseError: 'There is an error occurred.',
    clientError: 'An error occurred while sending API request.',
    serverError: 'API server failed to fulfil the request.',
    connectionError:
      'An error occurred while connecting to API server. Please check your network and try again later.',
    requestError: 'An error occurred while setting up an API request.',
    ARSError: {
      AFFILIATE_ID_REQUIRED:
        'Request failed. Please try again from your member page.',
      BOOKING_NOT_ENOUGH_ALLOTMENT:
        "Sorry, we don't have enough ticket inventory for the time slot that you have selected. Please choose a different date or time and try again.",
      BOOKING_NO_AVAILABILITY:
        "Sorry, we don't have enough ticket inventory for the time slot that you have selected. Please choose a different date or time and try again.",
      PERMISSION_DENIED: 'You do not have permission to access the resource.',
      NOT_FOUND: 'No resource found.',
      BOOKING_ALREADY_ISSUED: 'Redeemed or used voucher cannot be cancelled.',
      BOOKING_RESERVATION_OVERLIMIT: 'Reservation limit exceeded.'
    }
  },
  login: {
    title: 'Login / Sign Up',
    caption: 'Please select a method to log in or register as a member.',
    appleLogin: 'Apple',
    googleLogin: 'Google',
    email: 'Email address',
    emailConfirm: 'Email address (confirmation)',
    password: 'Password',
    button: 'Login',
    forgotPassword: 'Forgot your password?',
    newAccount: 'Sign Up',
    signInAgree: `*You can easily log in and register as a member with a third party's account. \n *By registering as a member using your email address or a third party's account, you are deemed to have agreed to the <TermsLink>{{terms}}</TermsLink> and <PrivacyLink>{{privacy}}</PrivacyLink>.`
  },
  password: {
    changePassword: 'Change password',
    resetPassword: 'Reset password',
    sendResetEmail: 'Send password reset email',
    sendResetEmailSuccess:
      'We send a link to {{email}}, please follow the link to reset your password.',
    oldPassword: 'Old password',
    newPassword: 'New password',
    changePasswordSuccess: 'Password changed successfully.'
  },
  date: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday'
  },
  profile: {
    title: 'Profile',
    firstName: 'First name(Half-width alphanumeric characters only)',
    lastName: 'Last name(Half-width alphanumeric characters only)',
    email: 'Email',
    confirmEmail: 'Email (confirmation)',
    password: 'Password',
    gender: 'Gender',
    birthday: 'Birthday',
    country: 'Country',
    prefecture: 'Prefecture',
    genderOptions: {
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    updateProfileSuccess: 'Profile updated successfully.',
    updateProfileFailed: 'Profile update failed, please try again later.'
  },
  weeks: {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土'
  },
  empty: {
    message: 'No content found'
  }
};
